// src/components/common/LazyLoadingSpinner.js
import React from 'react';

const LazyLoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
      <p className="text-gray-600 text-lg font-medium">{message}</p>
      <p className="text-gray-500 text-sm mt-2">This may take a moment...</p>
    </div>
  );
};

export default LazyLoadingSpinner;
